import { render } from "./AddSandboxCredentials.vue?vue&type=template&id=2f9edc4b"
import script from "./AddSandboxCredentials.vue?vue&type=script&lang=js"
export * from "./AddSandboxCredentials.vue?vue&type=script&lang=js"

import "./AddSandboxCredentials.vue?vue&type=style&index=0&id=2f9edc4b&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__